import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;
	padding: 1em 0;

	> ul {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0;
		margin: 0;
		margin-block: 0;

		@keyframes next {
			0% {
				transform: translateX(0);
			}

			50% {
				transform: translateX(1em);
			}

			100% {
				transform: translate(0);
			}
		}

		@keyframes prev {
			0% {
				transform: translateX(0);
			}

			50% {
				transform: translateX(-1em);
			}

			100% {
				transform: translate(0);
			}
		}

		.next {
			display: none;
			&:hover {
				animation: next 0.6s ease-in;
			}
		}

		.previous {
			display: none;
			&:hover {
				animation: prev 0.6s ease-in;
			}
		}

		.next,
		.previous {
			position: relative;

			&:after {
				content: '';
				position: absolute;
				width: 150%;
				height: 150%;
				left: 50%;
				transform: translateX(-50%);
				top: -25%;
				z-index: -1;
			}
		}

		> li {
			margin: 0.3em;
			list-style: none;
			font-size: 1.12em;
			cursor: pointer;

			a {
				color: #ebe8e8;
				text-decoration: none;
				transition: opacity 0.3s ease-in-out;
				border: 0.15em solid #ebe8e8;
				width: 2em;
				height: 2em;
				min-width: 2em;
				min-height: 2em;
				max-width: 2em;
				max-height: 2em;
				display: flex;
				place-content: center;
				place-items: center;
				border-radius: 100%;
				pointer-events: painted;
			}

			&.selected {
				a {
					font-weight: 600;
					color: #ffffff;
					border: 0.2em solid #ffffff;
				}
			}

			&:hover {
				a {
					color: ${vars.colorViolet};
					border-color: ${vars.colorViolet};

				}
			}

			.next-icon,
			.prev-icon {
				color: #ffffff;
				margin: 0 0.6em;
			}
		}
	}
`;
